import { Box, Grid, Typography } from '@mui/material';
import React from 'react';

const DecentralizedFuture = () => {
    return (
        <div>
            <Box sx={{ display: 'flex', alignItems: 'center', py: '20px' }}>
                <Box className="first-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#4741E4' }}></Box>
                <Box className="second-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#7E89FF' }}></Box>
                <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '20px', sm: '22px', md: '25px', lg: '30px' }, lineHeight: { xs: '30px', lg: '45px' }, color: '#383838', textAlign: 'left', pl: { xs: '18px', sm: '22px', md: '28px', lg: '36px' } }}>
                    Establishing A <span style={{ fontWeight: 700, color: '#433ED1' }}>Decentralized Future Together</span>
                </Typography>
            </Box>

            <Grid container sx={{ pt: '10px', pb: { xs: '20px', md: '28px' }, display: 'flex', alignItems: 'center' }}>
                {/* left side */}
                <Grid item xs={12} sm={6} sx={{}}>
                    <Box sx={{ pl: { xs: '10px', sm: '17px', md: '27px', lg: '50px', xl: '70px' } }}>
                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 400, fontSize: { xs: '16px', sm: '14px', md: '17px', lg: '18px' }, lineHeight: { xs: '30px', md: '40px', lg: '45px' }, color: '#383838', textAlign: 'left', mb: { xs: '8px', sm: 0 } }}>
                            Quantally is an enterprise grade public ledger that makes your digital world work just as it should. QNTL is the native cryptocurrency used for the settlement of transactions on Quantally. Quantally creates a fair and innovative ecosystem for the deployment of secure applications.
                        </Typography>
                    </Box>
                </Grid>
                {/* right size */}
                <Grid item xs={12} sm={6}>
                    <Box sx={{ background: '#EEEFFF', width: { xs: '326px', sm: '315px', md: '430px', lg: '560px', xl: '80%' }, height: { xs: '165px', sm: '215px', md: '270px', lg: '320px', xl: '350px' }, mx: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', mt: { xs: '20px', sm: 0 } }}>
                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 400, fontSize: { xs: '14px', sm: '16px', md: '18px', lg: '20px' }, lineHeight: { xs: '14px', sm: '16px', md: '18px', lg: '20px' }, color: '#433ED1', textAlign: 'center' }}>
                            Animation/illustration
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
};

export default DecentralizedFuture;